(() => {
  const video = document.querySelector('[data-royal-hero]');
  if (!video) return;
  const toggle = document.querySelector('.hero-video-toggle');
  const mobile = matchMedia('(max-width: 640px)');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  let userPaused = false;
  function sync() {
    toggle.hidden = reducedMotion.matches;
    if (reducedMotion.matches) {
      video.pause();
      video.classList.remove('is-ready');
      return;
    }
    const source = mobile.matches ? video.dataset.mobile : video.dataset.desktop;
    if (video.getAttribute('src') !== source) {
      video.classList.remove('is-ready');
      video.src = source;
      video.load();
    }
    if (userPaused || document.hidden) video.pause();
    else video.play().catch(() => updateButton(true));
    updateButton(userPaused);
  }
  function updateButton(paused) {
    toggle.classList.toggle('is-paused', paused);
    const label = paused ? 'Lire la vidéo' : 'Mettre la vidéo en pause';
    toggle.setAttribute('aria-label', label);
    toggle.title = label;
  }
  video.addEventListener('playing', () => {
    video.classList.add('is-ready');
    updateButton(false);
  });
  video.addEventListener('error', () => { video.classList.remove('is-ready'); toggle.hidden = true; });
  toggle.addEventListener('click', () => { userPaused = !userPaused; sync(); });
  mobile.addEventListener('change', sync);
  reducedMotion.addEventListener('change', sync);
  document.addEventListener('visibilitychange', sync);
  sync();
})();
